import React, { useState } from 'react'

import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons'
import { Checkbox, Spin } from 'antd'
import Button from 'components/Button'
import TableTransfer from './Transfer'
import {
  ButtonContainer,
  CenteredButtonsWrapper,
  StyledModal,
  BoldText,
  CancelButtonContainer,
  ExportButtonContainer,
} from './Style'

const ExportTransfer = ({
  open,
  columns,
  handleClose,
  data = [],
  handleExportType,
  handleExportClick,
  disabled = false,
  exportType,
  targetKeys = [],
  setTargetKeys,
  selectedKeys = [],
  setSelectedKeys,
  setExportLoading,
  exportLoading,
}) => {
  const [dataEnable, setDataEnable] = useState(false)
  const onChange = nextTargetKeys => {
    const check = data.filter(item => nextTargetKeys?.includes(item.key))
    setSelectedKeys(check)
    setTargetKeys(nextTargetKeys)
  }
  const [selectedItems, setSelectedItems] = useState([])
  const handleMoveAllLeft = () => {
    setTargetKeys([])
    setSelectedKeys([])
  }

  const handleMoveAllRight = () => {
    setTargetKeys(data.map(item => item.key))
    setSelectedKeys(data)
  }
  const renderHeader = () => {
    const totalItems = data.length
    return `1/${totalItems}`
  }

  const getformat = [
    {
      name: 'googlesheet',
      key: 'Google Sheet',
    },
    { name: 'csv', key: 'CSV' },
    { name: 'xlsx', key: 'XLSX' },
  ]
  return (
    <StyledModal open={open} centered>
      <Spin
        tip="Exporting..."
        size="large"
        spinning={exportLoading}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <>
          <BoldText>
            Select the columns you want to display on your report
          </BoldText>
          <CenteredButtonsWrapper>
            <Button
              onClick={handleMoveAllRight}
              disabled={
                targetKeys?.length === data?.length || selectedItems.length
              }
              style={{
                position: 'absolute',
                zIndex: 999,
                transform: 'translate(521%, 152%)',
                width: '63px',
                height: '53px',
                backgroundColor: 'white',
                padding: '0px',
              }}
            >
              <DoubleRightOutlined
                style={{ color: '#999FAC', fontSize: '22px' }}
              />
            </Button>

            <TableTransfer
              dataSource={data}
              targetKeys={targetKeys}
              disabled={disabled}
              showSelectAll={false}
              onChange={onChange}
              pagination={false}
              id="Modal"
              getPopupContainer={() => document.getElementById('Modal')}
              leftColumns={columns}
              rightColumns={columns}
              titles={[renderHeader(), renderHeader()]}
              setDataEnable={setDataEnable}
              dataEnable={dataEnable}
              setSelectedItems={setSelectedItems}
              selectedItems={selectedItems}
            />
            <Button
              onClick={handleMoveAllLeft}
              disabled={!targetKeys.length || selectedItems.length}
              style={{
                position: 'absolute',
                zIndex: 999,
                transform: 'translate(521%, -249%)',
                width: '63px',
                height: '53px',
                backgroundColor: 'white',
                padding: '0px',
              }}
            >
              <DoubleLeftOutlined
                style={{ color: '#999FAC', fontSize: '22px' }}
              />
            </Button>
          </CenteredButtonsWrapper>
          <ButtonContainer>
            <CancelButtonContainer>
              <Button
                type="default"
                onClick={() => handleClose(false)}
                style={{ marginRight: 8, backgroundColor: 'white' }}
              >
                {open ? 'Cancel' : 'Ok'}
              </Button>
            </CancelButtonContainer>

            <ExportButtonContainer>
              {getformat.map(item => (
                <Checkbox
                  onChange={() => handleExportType(item.name)}
                  checked={exportType === item.name}
                  key={item.name}
                >
                  {item.key}
                </Checkbox>
              ))}
              <Button
                type="primary"
                onClick={handleExportClick}
                disabled={!exportType || !targetKeys?.length}
              >
                Export
              </Button>
            </ExportButtonContainer>
          </ButtonContainer>
        </>
      </Spin>
    </StyledModal>
  )
}

export default ExportTransfer
